import {
  Navigate,
  Route,
  Routes,
  matchPath,
  useLocation,
} from 'react-router-dom';
import routes from './routes/routes';
import SendActivity from './sendActivity';
import { lazy, Suspense, useContext } from 'react';
import { IRouteConfig } from './interfaces/routeConfig';
import { ContextApp } from './contexts/ContextApp';
import { PageLoading } from '@ant-design/pro-layout';

const RegisteredLayout = lazy(() => import('./layouts/registered'));
const PublicLayout = lazy(() => import('./layouts/publicLayout'));

const AppContent = () => {
  const { t, user } = useContext(ContextApp);
  const { pathname } = useLocation();

  const translateRoutes = (items: IRouteConfig[]): IRouteConfig[] => {
    return items.map((route) => ({
      ...route,
      name: route.translation_key
        ? t(route.translation_key as never)
        : route.name,
      routes: route.routes ? translateRoutes(route.routes) : undefined,
    }));
  };
  const appRoute = routes.find((route) => route.path === '/app');
  const publicLayoutRoute = routes.find(
    (route) => route.path === '/' && route.routes,
  );
  const defaultRoute = routes.find(
    (route) => route.path === '/' && !route.routes,
  );

  const appRoutes = translateRoutes(appRoute?.routes ?? []);
  const publicRoutes = translateRoutes([
    ...(defaultRoute ? [defaultRoute] : []),
    ...(publicLayoutRoute?.routes ?? []),
  ]);

  SendActivity();
  // App validates the stored session before mounting routes. Reuse that user
  // rather than treating a stored token as proof of authentication.
  if (user && matchPath('/login', pathname)) {
    return <Navigate to="/app/home" replace />;
  }
  // Ant Design pages use ordinary React mounting/unmounting, without Ionic's
  // cached page stack. Keep Ionic's router for the existing NavContext calls.
  return (
    <Routes>
      <Route
        path="/app/*"
        element={
          <Suspense fallback={<PageLoading />}>
            <RegisteredLayout routes={appRoutes} />
          </Suspense>
        }
      />
      <Route
        path="/*"
        element={
          <Suspense fallback={<PageLoading />}>
            <PublicLayout routes={publicRoutes} />
          </Suspense>
        }
      />
    </Routes>
  );
};

export default AppContent;
